// Shared style tokens + icon map for the email builder. Kept in one place
// so refreshing the palette doesn't require sweeping EmailBuilder.tsx.

import BrushIcon from '@mui/icons-material/Brush';
import CodeIcon from '@mui/icons-material/Code';
import HeightIcon from '@mui/icons-material/Height';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import ImageIcon from '@mui/icons-material/Image';
import LayersIcon from '@mui/icons-material/Layers';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import MenuIcon from '@mui/icons-material/Menu';
import ShareIcon from '@mui/icons-material/Share';
import StorefrontIcon from '@mui/icons-material/Storefront';
import SubjectIcon from '@mui/icons-material/Subject';
import TouchAppIcon from '@mui/icons-material/TouchApp';
import ViewAgendaIcon from '@mui/icons-material/ViewAgenda';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import ViewStreamIcon from '@mui/icons-material/ViewStream';
import type { SvgIconComponent } from '@mui/icons-material';

export const BORDER = '#E5E7EB';
export const BORDER_SOFT = '#F3F4F6';
export const TEXT_DIM = '#6B7280';
export const TEXT = '#111827';
export const INDIGO = '#6366F1';
export const INDIGO_BG = '#EEF2FF';
export const INDIGO_TEXT = '#4338CA';

export const NODE_ICON: Record<string, SvgIconComponent> = {
  email: MailOutlineIcon,
  head: CodeIcon,
  wrapper: LayersIcon,
  section: ViewAgendaIcon,
  group: ViewColumnIcon,
  column: ViewStreamIcon,
  text: SubjectIcon,
  image: ImageIcon,
  button: TouchAppIcon,
  divider: HorizontalRuleIcon,
  spacer: HeightIcon,
  social: ShareIcon,
  navbar: MenuIcon,
  'product-feed': StorefrontIcon,
  'canvas-section': BrushIcon,
  'canvas-shape': ViewAgendaIcon,
  'canvas-text': SubjectIcon,
  'canvas-image': ImageIcon,
  'canvas-path': BrushIcon,
  'canvas-group': LayersIcon,
};
